/****************************************************************************
* Theme scripts.
****************************************************************************/

( function( $ ) {
    'use strict';

	/*****************
	* Initiate independent functions
	*****************/
	function fnInit() {

		/**
		* Scripts (only run when section is visible)
		*/
		fnLazyLoading();														// Lazy loading | https://github.com/ApoorvSaxena/lozad.js
        $( 'header.primary' ).each( fnHeaderPrimary );            				// Header primary
        $( 'section.home-slides' ).each( fnHomeSlides );            			// Homepage hero & slides (fullPage.js) | https://github.com/alvarotrigo/fullPage.js
		fnInViewDetect();														// In-view detection | https://github.com/zeusdeux/isInViewport
        $( 'article.builder--01' ).each( fnBuilders );                          // Flexible content builders
		$( 'body' ).addClass( 'page-loaded' );									// Page loaded class
        $( 'footer.primary' ).each( fnFooterPrimary );            				// Footer primary
        $( 'section.client-list' ).each( fnClientList );            			// Client list
        $( 'section.article-list' ).each( fnArticleList );            			// Article list
        $( '.paroller, [data-paroller-factor]' ).each( fnParoller );            // Paroller (parallax)
        
	}
    fnInit();

} ( jQuery ) );


// END OF DOCUMENT